import { print } from "graphql";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, tap } from "rxjs/operators";
import { Processo } from "@/models/processo";
import { BeneficiarioBaseAPI } from "./beneficiario.base.api";

const processoShow = require("@/query/passe-livre/ProcessoShow.graphql");

export class ProcessoAPI extends BeneficiarioBaseAPI<Processo> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/passe-livre/processo`;
  }

  public show(processoId: number): AxiosObservable<Processo> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(processoShow),
        variables: { processoId }
      })
      .pipe(
        map((data: any) => {
          const { processo } = data;

          return processo;
        })
      );
  }
}
